import React, { Suspense, lazy, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { Helmet } from "react-helmet";
import ScrollToTop from "./ScrollToTop";
import Home from "./Home";
import Error from "./pages/Error";
import "../src/stylesheet.css";
import "../src/font/stylesheet.css";

// ✅ Lazy load non-critical pages
const Our_story = lazy(() => import("./Our-story"));
const Our_products = lazy(() => import("./Our-products"));
const Infrastructure = lazy(() => import("./Infrastructure"));
const Csr = lazy(() => import("./Csr"));
const Career = lazy(() => import("./Career"));
const Contact = lazy(() => import("./Contact"));
const Dealers = lazy(() => import("./Dealers"));
const FeedbackForm = lazy(() => import("./FeedbackForm"));
const Suppliers = lazy(() => import("./Suppliers"));
const Vendor = lazy(() => import("./Vendor"));
const Tendor = lazy(() => import("./Tendor"));
const ProductDetails = lazy(() => import("./pages/ProductDetails"));
const Content = lazy(() => import("./Content"));
const Privacy = lazy(() => import("./Privacy"));
const Terms = lazy(() => import("./Terms"));
const Sitemap = lazy(() => import("./Sitemap"));
const ThnakYou = lazy(() => import("./ThnakYou"));
const Accordians = lazy(() => import("./pages/Accordians"));

// ✅ Loading spinner (simple CSS loader)
const LoadingFallback = () => (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#fff",
      zIndex: 9999,
    }}
  >
    <div
      style={{
        width: "50px",
        height: "50px",
        border: "4px solid #eee",
        borderTop: "4px solid #e30613",
        borderRadius: "50%",
        animation: "spin 1s linear infinite",
      }}
    ></div>
  </div>
);

const App = () => {
  // ✅ Preload some routes for better performance after first load
  useEffect(() => {
    const preloadModules = [
      import("./Our-products"),
      import("./Our-story"),
      import("./Infrastructure"),
    ];
    preloadModules.forEach((p) => p.catch(() => {}));
  }, []);

  return (
    <>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>

      <ScrollToTop />
      <Helmet>
        <title>Redcow Dairy</title>
        <meta
          name="description"
          content="Redcow Dairy — delivering purity and freshness through our range of dairy products."
        />
        <meta name="keywords" content="Redcow Dairy, milk, ghee, butter, curd" />
        <link rel="canonical" href="https://www.redcow.in/" />
      </Helmet>

      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/our-story" element={<Our_story />} />
          <Route path="/our-products/:slug" element={<ProductDetails />} />
          <Route path="/our-products" element={<Our_products />} />
          <Route path="/our-infrastructure" element={<Infrastructure />} />
          <Route path="/our-csr" element={<Csr />} />
          <Route path="/career" element={<Career />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/dealers-enquiry" element={<Dealers />} />
          <Route path="/customer-feedback" element={<FeedbackForm />} />
          <Route path="/suppliers-enquiry" element={<Suppliers />} />
          <Route path="/vendor-registration" element={<Vendor />} />
          <Route path="/tender-management" element={<Tendor />} />
          <Route path="/cookies-policy" element={<Content />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/terms-of-use" element={<Terms />} />
          <Route path="/sitemap" element={<Sitemap />} />
          <Route path="/thank-you" element={<ThnakYou />} />
          <Route path="/accordians" element={<Accordians />} />
          <Route path="*" element={<Error />} />
        </Routes>
      </Suspense>
    </>
  );
};

export default App;
